var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnderConstruction = function SvgUnderConstruction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 394,
    height: 259,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7EBF2",
    d: "M41.463 237.396h47.805v3.879H41.463z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7EBF2",
    d: "M44.418 228.705a3 3 0 0 1 2.852-2.071h36.315a3 3 0 0 1 2.853 2.071l2.83 8.691h-47.68z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7EBF2",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M26.696 72.457V87.1h136.906l-13.265-13.39z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7EBF2",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M104.41 87.099v-13.39l15.267 13.39v-13.39l15.393 13.39v-13.39l15.267 13.39v-13.39M43.09 87.099V72.707M89.017 73.709v13.39L73.75 73.709M73.75 73.709v13.39M57.23 220.376h16.395V58.816l-8.26-7.633-8.134 7.634z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7EBF2",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M73.625 59.693H57.23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7EBF2",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M73.625 100.99H57.23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7EBF2",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M73.625 114.255H57.23M73.625 127.395H57.23M73.625 140.66H57.23M73.625 153.925H57.23M73.625 167.19H57.23M73.625 180.33H57.23M73.625 193.596H57.23M73.625 206.861H57.23"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7EBF2",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m138.198 73.583-72.833-22.4-34.664 21.4M73.75 87.099 57.23 72.957M57.731 87.6l15.518 12.889M57.731 59.943l15.643 12.514M43.59 72.958l13.015 13.89M42.714 86.848l-15.893-13.89M89.518 73.584l14.391 12.89M57.857 101.365l15.392 12.39M57.857 114.756l15.392 12.138M57.731 127.896 73.25 140.16M57.731 141.286l15.518 12.139M57.731 154.426l15.518 12.139M57.731 167.566 73.25 179.83M57.731 180.831l15.518 12.264M57.731 194.096 73.25 206.36M57.731 207.486l15.518 12.139"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7EBF2",
    d: "M49.72 220.251h31.29a2 2 0 0 1 2 2v4.382H47.72v-4.382a2 2 0 0 1 2-2M91.52 99.238l-9.386 9.386c-.626.625-1.502 1.001-2.252 1.001H56.355V87.6h36.291v9.26c-.25 1.001-.5 1.752-1.126 2.378"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.139 97.597h-9.013a1 1 0 0 1-1-1v-4.382a1 1 0 0 1 1-1h9.012a1 1 0 0 1 1 1v4.382a1 1 0 0 1-1 1M84.375 97.597h-9.013a1 1 0 0 1-1-1v-4.382a1 1 0 0 1 1-1h9.013a1 1 0 0 1 1 1v4.382a1 1 0 0 1-1 1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9C0D0",
    d: "M29.15 202.15h-4.908v40.045h4.907zM63.972 202.15h-4.907v40.045h4.907z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__a)",
    d: "M212.125 240.771c-13.296.316-29.125 0-40.363-.159-11.238.317-27.066.475-40.362.159 13.138-7.44 17.57-21.21 18.361-30.391h43.844c.95 9.181 5.382 22.951 18.52 30.391"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EDF8",
    d: "M254.228 95.15v113.806c0 2.849-2.216 4.907-4.907 4.907H94.204c-2.691 0-4.907-2.216-4.907-4.907V95.15c0-2.69 2.216-4.906 4.907-4.906H249.32c2.691 0 4.907 2.057 4.907 4.906"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9C0D0",
    d: "M254.228 95.15v98.136H89.455V95.15c0-2.69 2.216-4.906 4.907-4.906h155.117c2.533 0 4.749 2.057 4.749 4.906"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M248.371 96.258H95.311v91.329h152.902v-91.33z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9C0D0",
    d: "M171.762 207.531a4.115 4.115 0 1 0 .001-8.23 4.115 4.115 0 0 0-.001 8.23M344.717 206.582h-4.274v35.139h4.274zM375.266 206.582h-4.274v35.139h4.274z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EDF8",
    d: "M380.647 208.165h-44.952v14.403h44.952z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__b)",
    d: "m346.617 208.165-4.749 14.403h-5.382l4.591-14.403z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__c)",
    d: "m357.538 208.165-4.749 14.403h-5.381l4.59-14.403z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__d)",
    d: "m368.459 208.165-4.748 14.403h-5.382l4.591-14.403z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__e)",
    d: "m379.381 208.165-4.748 14.403h-5.382l4.59-14.403z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EDF8",
    d: "M70.145 204.049H18.86v16.462h51.284z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__f)",
    d: "m31.207 204.049-5.382 16.303h-6.173l5.382-16.303z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__g)",
    d: "m43.711 204.049-5.381 16.303h-6.173l5.223-16.303z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__h)",
    d: "m56.216 204.049-5.382 16.303h-6.173l5.223-16.303z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__i)",
    d: "m68.72 204.049-5.382 16.303h-6.173l5.224-16.303z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BBC1CF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M191.864 46.083v19.31"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9C0D0",
    d: "M191.943 73.782a5.62 5.62 0 1 0 .001-11.239 5.62 5.62 0 0 0-.001 11.24"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BBC1CF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M186.483 83.121c0 3.482 3.165 6.331 6.964 5.382a5.464 5.464 0 0 0 4.116-4.116c.633-3.007-1.108-5.856-3.799-6.648-.95-.316-1.583-1.108-1.583-2.216v-4.906"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__j)",
    d: "M328.621 236.972h-60.464v4.907h60.464z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD0DD",
    d: "M324.705 225.431a3 3 0 0 0-2.853-2.071h-47.085a3 3 0 0 0-2.853 2.071l-3.757 11.541h60.306z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BBC1CF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M347.298 28.355v18.519H174.136l16.778-16.937z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BBC1CF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M249.004 46.874V29.937l-19.31 16.937V29.937l-19.469 16.937V29.937l-19.311 16.937V29.937M326.563 46.874V28.67M268.473 29.937v16.937l19.311-16.937M287.784 29.937v16.937M308.677 215.445h-20.735V11.102l10.447-9.656 10.288 9.656z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BBC1CF",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M287.942 12.21h20.735"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BBC1CF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M287.942 64.443h20.735"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BBC1CF",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M287.942 81.22h20.735M287.942 97.84h20.735M287.942 114.619h20.735M287.942 131.397h20.735M287.942 148.175h20.735M287.942 164.794h20.735M287.942 181.573h20.735M287.942 198.35h20.735"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BBC1CF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m206.268 29.779 92.121-28.333 43.844 27.067M287.784 46.873l20.893-17.886M308.044 47.507 288.417 63.81M308.044 12.526l-19.785 15.828M325.93 28.987l-16.461 17.57M327.038 46.557l20.102-17.57M267.84 29.779l-18.203 16.303M307.886 64.918l-19.469 15.67M307.886 81.854l-19.469 15.354M308.044 98.474l-19.627 15.512M308.044 115.41l-19.627 15.354M308.044 132.03l-19.627 15.353M308.044 148.65l-19.627 15.511M308.044 165.428l-19.627 15.512M308.044 182.206l-19.627 15.511M308.044 199.142l-19.627 15.353"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__k)",
    d: "M318.707 215.287h-40.636a2 2 0 0 0-2 2v6.073h44.636v-6.073a2 2 0 0 0-2-2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EDF8",
    d: "M122.853 182.048h-19.627a2.837 2.837 0 0 1-2.849-2.849V103.54a2.838 2.838 0 0 1 2.849-2.85h19.627a2.838 2.838 0 0 1 2.849 2.85v75.659a2.837 2.837 0 0 1-2.849 2.849"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__l)",
    d: "M113.039 115.885a4.749 4.749 0 1 0 0-9.497 4.749 4.749 0 0 0 0 9.497"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__m)",
    d: "M121.428 122.85H104.65c-.316 0-.475-.159-.475-.475v-1.266c0-.317.159-.475.475-.475h16.62c.317 0 .475.158.475.475v1.266c.158.316-.158.475-.317.475"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__n)",
    d: "M121.428 129.497H104.65c-.316 0-.475-.158-.475-.474v-1.267c0-.316.159-.475.475-.475h16.62c.317 0 .475.159.475.475v1.267c.158.316-.158.474-.317.474"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__o)",
    d: "M121.428 136.146H104.65c-.316 0-.475-.159-.475-.475v-1.266c0-.317.159-.475.475-.475h16.62c.317 0 .475.158.475.475v1.266c.158.316-.158.475-.317.475"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__p)",
    d: "M121.428 142.952H104.65c-.316 0-.475-.159-.475-.475v-1.267c0-.316.159-.474.475-.474h16.62c.317 0 .475.158.475.474v1.267c.158.158-.158.475-.317.475"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__q)",
    d: "M121.428 149.6H104.65c-.316 0-.475-.159-.475-.475v-1.266c0-.317.159-.475.475-.475h16.62c.317 0 .475.158.475.475v1.266c.158.158-.158.475-.317.475"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__r)",
    d: "M121.428 156.247H104.65c-.316 0-.475-.158-.475-.475v-1.266c0-.316.159-.475.475-.475h16.62c.317 0 .475.159.475.475v1.266c.158.317-.158.475-.317.475"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__s)",
    d: "M118.421 162.895h-10.605c-.317 0-.475-.158-.475-.474v-1.267c0-.316.158-.475.475-.475h10.605c.317 0 .475.159.475.475v1.267c0 .316-.317.474-.475.474"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__t)",
    d: "M181.893 170.651h-42.262v2.374h42.262z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__u)",
    d: "M162.582 176.982h-22.951v2.374h22.951z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__v)",
    d: "M232.701 170.651H190.44v2.374h42.261z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__w)",
    d: "M213.391 176.982H190.44v2.374h22.951z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BBC1CF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M154.893 93.487 188.4 86.82a9.185 9.185 0 0 1 6.841 1.228l25.788 14.912"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#under-construction_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m220.66 173.657-84.871-12.806c-2.631-.351-4.385-2.807-4.035-5.439l8.596-61.224c.351-2.631 2.807-4.385 5.439-4.035l84.871 12.807c2.631.35 4.385 2.806 4.035 5.438l-8.596 61.224c-.351 2.456-2.807 4.386-5.439 4.035"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF3FB",
    d: "m217.881 166.689-75.867-11.849c-2.145-.286-3.575-2.288-3.289-4.432l7.006-49.901c.286-2.145 2.288-3.575 4.432-3.288l75.868 11.849c2.145.286 3.575 2.287 3.289 4.432l-7.006 49.901c-.286 2.002-2.288 3.574-4.433 3.288"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9C0D0",
    d: "M265.308 62.227 277.179 74.1c.791.791 1.899 1.266 2.849 1.266h29.757V47.507h-45.902V59.22c.317 1.266.633 2.216 1.425 3.007"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M292.086 60.152h11.929a1 1 0 0 0 1-1V53.08a1 1 0 0 0-1-1h-11.929a1 1 0 0 0-1 1v6.072a1 1 0 0 0 1 1M274.08 60.152h11.929a1 1 0 0 0 1-1V53.08a1 1 0 0 0-1-1H274.08a1 1 0 0 0-1 1v6.072a1 1 0 0 0 1 1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CDD6E1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M2.083 242.195h389.975"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EDF8",
    d: "M136.932 240.93h-21.368l.949-2.375 2.216-6.014 1.9-5.224 2.216-6.014 1.583-4.116c.316-.791 1.108-1.424 1.899-1.424.791 0 1.583.475 1.899 1.424l1.583 4.116 2.216 6.014 1.9 5.224 2.216 6.014z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__y)",
    d: "M132.031 227.317h-11.39l2.141-5.856h7.078z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__z)",
    d: "M136.134 238.556h-19.627l2.216-6.015h15.195z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EDF8",
    d: "M136.932 240.93h-21.527c-.633 0-1.266-.475-1.266-1.266 0-.633.475-1.267 1.266-1.267h21.527c.633 0 1.266.475 1.266 1.267 0 .791-.475 1.266-1.266 1.266M254.03 240.93h-21.369l.95-2.375 2.216-6.014 1.899-5.224 2.216-6.014 1.583-4.116c.317-.791 1.108-1.424 1.9-1.424.791 0 1.582.475 1.899 1.424l1.583 4.116 2.216 6.014 1.899 5.224 2.216 6.014z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__A)",
    d: "M249.129 227.317h-11.39l2.141-5.856h7.078z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#under-construction_svg__B)",
    d: "M253.231 238.556h-19.627l2.216-6.015h15.195z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EDF8",
    d: "M254.03 240.93h-21.527c-.633 0-1.266-.475-1.266-1.266 0-.633.475-1.267 1.266-1.267h21.527c.633 0 1.266.475 1.266 1.267 0 .791-.475 1.266-1.266 1.266"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#989FB0",
    d: "M167.1 133.793c2.242.341 4.426-1.267 4.767-3.509.34-2.241-1.268-4.425-3.509-4.766-2.241-.34-4.426 1.268-4.766 3.509-.341 2.241 1.267 4.425 3.508 4.766M198.82 138.613c2.241.341 4.426-1.267 4.766-3.508.341-2.242-1.267-4.426-3.508-4.767-2.242-.34-4.426 1.268-4.767 3.509-.366 2.413 1.268 4.426 3.509 4.766M169.648 115.943l-9.848 3.531.882 2.462 9.848-3.531zM200.976 120.637l-1.574 2.089 8.356 6.296 1.574-2.089zM181.493 145.857c2.666.405 5.073-.888 5.377-2.887.304-1.999-1.611-3.949-4.277-4.354-2.665-.405-5.073.888-5.377 2.887-.303 1.999 1.611 3.949 4.277 4.354"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CDD6E1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M114.617 256.511h210.275M46.223 256.511h26.573"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__a",
    x1: 171.833,
    x2: 171.833,
    y1: 240.016,
    y2: 212.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#D8E0EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__b",
    x1: 341.552,
    x2: 341.552,
    y1: 208.165,
    y2: 222.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__c",
    x1: 352.473,
    x2: 352.473,
    y1: 208.165,
    y2: 222.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__d",
    x1: 363.394,
    x2: 363.394,
    y1: 208.165,
    y2: 222.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__e",
    x1: 374.316,
    x2: 374.316,
    y1: 208.165,
    y2: 222.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__f",
    x1: 25.43,
    x2: 25.43,
    y1: 204.049,
    y2: 220.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__g",
    x1: 37.934,
    x2: 37.934,
    y1: 204.049,
    y2: 220.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__h",
    x1: 50.438,
    x2: 50.438,
    y1: 204.049,
    y2: 220.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__i",
    x1: 62.943,
    x2: 62.943,
    y1: 204.049,
    y2: 220.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__j",
    x1: 268.102,
    x2: 328.519,
    y1: 239.333,
    y2: 239.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__k",
    x1: 276.135,
    x2: 320.727,
    y1: 219.382,
    y2: 219.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__l",
    x1: 116.01,
    x2: 110.026,
    y1: 106.388,
    y2: 106.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__m",
    x1: 118.49,
    x2: 107.394,
    y1: 120.634,
    y2: 120.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__n",
    x1: 118.49,
    x2: 107.394,
    y1: 127.281,
    y2: 127.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__o",
    x1: 118.49,
    x2: 107.394,
    y1: 133.93,
    y2: 133.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__p",
    x1: 118.49,
    x2: 107.394,
    y1: 140.736,
    y2: 140.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__q",
    x1: 118.49,
    x2: 107.394,
    y1: 147.384,
    y2: 147.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__r",
    x1: 118.49,
    x2: 107.394,
    y1: 154.031,
    y2: 154.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__s",
    x1: 116.733,
    x2: 109.453,
    y1: 160.679,
    y2: 160.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__t",
    x1: 173.98,
    x2: 147.354,
    y1: 170.651,
    y2: 170.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__u",
    x1: 158.285,
    x2: 143.825,
    y1: 176.982,
    y2: 176.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__v",
    x1: 224.789,
    x2: 198.163,
    y1: 170.651,
    y2: 170.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__w",
    x1: 209.094,
    x2: 194.634,
    y1: 176.982,
    y2: 176.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__y",
    x1: 129.899,
    x2: 122.723,
    y1: 221.461,
    y2: 221.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__z",
    x1: 132.459,
    x2: 120.093,
    y1: 232.541,
    y2: 232.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__A",
    x1: 246.996,
    x2: 239.821,
    y1: 221.461,
    y2: 221.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "under-construction_svg__B",
    x1: 249.557,
    x2: 237.191,
    y1: 232.541,
    y2: 232.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD3DE"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "under-construction_svg__x",
    width: 147.029,
    height: 127.589,
    x: 109.71,
    y: 85.109,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgUnderConstruction;